import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailCompose from "../pages/Email/email-compose"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//Charts

// import ChartsJs from "../pages/Charts/charts-chartjs"
// import ChartsKnob from "../pages/Charts/charts-knob"
// import ChartsSparkLine from "../pages/Charts/charts-sparkline"

// Maps
// import MapsGoogle from "../pages/Maps/MapsGoogle"
// import MapsVector from "../pages/Maps/MapsVector"

//Icons
// import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
// import Iconion from "../pages/Icons/Iconion"
// import IconFontawesome from "../pages/Icons/IconFontawesome"
// import IconThemify from "../pages/Icons/IconThemify"
// import IconDripicons from "../pages/Icons/IconDripicons"
// import IconTypicons from "../pages/Icons/IconTypicons"

//Tables
// import BasicTables from "../pages/Tables/BasicTables"
// import DatatableTables from "../pages/Tables/DatatableTables"
// import ResponsiveTables from "../pages/Tables/ResponsiveTables"

// Forms
// import FormElements from "../pages/Forms/FormElements"
// import FormAdvanced from "../pages/Forms/FormAdvanced"
// import FormEditors from "../pages/Forms/FormEditors"
// import FormValidations from "../pages/Forms/FormValidations"
// import FormUpload from "../pages/Forms/FormUpload"

//Ui
// import UiAlert from "../pages/Ui/UiAlert"
// import UiButtons from "../pages/Ui/UiButtons"
// import UiBadge from "../pages/Ui/UiBadge"
// import UiCards from "../pages/Ui/UiCards"
// import UiCarousel from "../pages/Ui/UiCarousel"
// import UiDropdown from "../pages/Ui/UiDropdown"
// import UiGrid from "../pages/Ui/UiGrid"
// import UiImages from "../pages/Ui/UiImages"
// import UiLightbox from "../pages/Ui/UiLightbox"
// import UiModal from "../pages/Ui/UiModal"
// import UiPagination from "../pages/Ui/UiPagination"
// import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
// import UiProgressbar from "../pages/Ui/UiProgressbar"
// import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
// import UiTypography from "../pages/Ui/UiTypography"
// import UiVideo from "../pages/Ui/UiVideo"
// import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
// import UiRangeSlider from "../pages/Ui/UiRangeSlider"

//Extra Pages
// import PagesTimeline from "../pages/Extra Pages/pages-timeline"
// import PagesInvoice from "../pages/Extra Pages/pages-invoice"
// import PagesDirectory from "../pages/Extra Pages/pages-directory"
// import PagesBlank from "../pages/Extra Pages/pages-blank"
import Pages404 from "../pages/Extra Pages/pages-404"
import Pages500 from "../pages/Extra Pages/pages-500"
// import UiUtilities from "pages/Ui/UiUtilities"
// import UiColors from "pages/Ui/UiColors"
// import UiOffcanvas from "pages/Ui/UiOffcanvas"
// import Chat from "pages/Chat/Chat"
// import Kanban from "pages/Kanban"
import UniversityList from "pages/University/UniversityList/UniversityList"
import AddUniversity from "pages/University/AddUniversity/AddUniversity"
import InstitutionDataTable from "pages/Institution/InstitutionDataTable/AllInstitution"
import AddInstitution from "pages/Institution/AddInstitution/AddInstitution"
import ProrgamList from "pages/Program/ProrgamList/ProgramList"
import CourseList from "pages/Courses/CoursesList/CourseList"
import ProgramList from "pages/Program/ProrgamList/ProgramList"
import ViewUniversity from "pages/University/ViewUniversity/ViewUniversity"
import EditUniversity from "pages/University/EditUniversity/EditUniversity"
import ViewInstitution from "pages/Institution/ViewInstitution/ViewInstitution"
import EditInstitution from "pages/Institution/EditInstitution/EditInstitution"
import AddProgram from "pages/Program/AddProgram/AddProgram"
import AddCourse from "pages/Courses/AddCourses/AddCourse"
import EditCourse from "pages/Courses/EditCourse/EditCourse"
import ViewProgram from "pages/Program/ViewProgram/ViewProgram"
import ViewCourse from "pages/Courses/ViewCourse/ViewCourse"
import Categorytable from "pages/Category/CategoryTable/Categorytable"
import AddCategory from "pages/Category/AddCategory/AddCategory"
import ViewCategory from "pages/Category/ViewCategory/ViewCategory"
import EditCategory from "pages/Category/EditCategory/EditCategory"
import EditProgram from "pages/Program/EditProgram/EditProgram"
import UserList from "pages/Users/UsersList/UserList"
import Tasklist from "pages/Task/TaskList/taskList"
import AssignTask from "pages/Task/AssignTask/assignTask"
import EditTask from "pages/Task/EditTask/EditTask"
import TaskDataTable from "pages/Task/Analyst/TaskDataTable/TaskDataTable"
import ViewTask from "pages/Task/Analyst/ViewTask/viewTask"
import Settings from "pages/Authentication/Settings"
import PortalUsers from "pages/Users/PortalUser/PortalUsers"

import EmailTemplateTable from "pages/EmailTemplate/EmailTemplateTable/EmailTemplateTable"



import ViewAppUser from "pages/Users/UsersList/ViewAppUser/ViewAppUser"
import VerifyBusinessUser from "pages/Users/BusinessUserList/VerifyBusinessUser/VerifyBusinessUser"
import ViewPortalUser from "pages/Users/PortalUser/ViewPortalUser/ViewPortalUser"
import ViewEmailTemplate from "pages/EmailTemplate/viewEmailTemplate/viewEmailTemplate"
import AppEditEmailTemplate from "pages/EmailTemplate/AppEditEmailTemplate/AppEditEmailTemplate"
import UserPostFeed from "pages/Users/UsersList/ViewAppUser/UserPostFeed/UserPostFeed"
import AppAddEmailTemplate from "pages/EmailTemplate/AppAddEmailTemplate/AppAddEmailTemplate"
import DeletedUsers from "pages/Deleted/DeletedUsers/DeletedUsers"
import DeletedGabs from "pages/Deleted/DeletedGabs/DeletedGabs"
import DeletedComments from "pages/Deleted/DeletedComments/DletedComments"
import SiteSettings from "pages/SiteSettings/SiteSettings"
import InstitutionListTable from "pages/Institution/InstitutionListTable/InstitutionListTable"
import Under18Users from "pages/Users/UsersList/ViewAppUser/Under18Users/Under18Users"
import EmailSubcription from "pages/EmailSubscription/EmailSubcription"
import ClaimRequest from "pages/Users/BusinessUserList/ClaimRequest"
import BusinessUserList from "pages/Users/BusinessUserList/BusinessUserList/BusinessUserList"
//payment
import Tickets from "pages/Payments/Tickets/Tickets"
import Transactions from "pages/Payments/Transactions/Transactions"
import Requests from "pages/Payments/Requests/Requests"

//KYC
import KYC from "pages/KYC/KYC"

//Forms
import FormList from "pages/Forms/FormList/FormList"
import AddForm from "pages/Forms/AddForm/AddForm"
import EditForm from "pages/Forms/EditForm/EditForm"
import ResponseList from "pages/Forms/ResponseList/ResponseList"
import ViewResponse from "pages/Forms/ViewResponse/ViewResponse"


const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //calendar
  // { path: "/calendar", component: <Calendar /> },

  // { path: "/chat", component: <Chat /> },
  // { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/settings", component:<Settings/>},


  // //Email
  // { path: "/email-inbox", component: <EmailInbox /> },
  // { path: "/email-read", component: <EmailRead /> },
  // { path: "/email-compose", component: <EmailCompose /> },

  // //Charts
  // { path: "/apex-charts", component: <ChartsAppex /> },
  // { path: "/charts-chartjs", component: <ChartsJs /> },
  // { path: "/charts-knob", component: <ChartsKnob /> },
  // { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // Icons
  // { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  // { path: "/icons-ion", component: <Iconion /> },
  // { path: "/icons-fontawesome", component: <IconFontawesome /> },
  // { path: "/icons-themify", component: <IconThemify /> },
  // { path: "/icons-dripicons", component: <IconDripicons /> },
  // { path: "/icons-typicons", component: <IconTypicons /> },

  // // Tables
  // { path: "/tables-basic", component: <BasicTables /> },
  // { path: "/tables-datatable", component: <DatatableTables /> },
  // { path: "/tables-responsive", component: <ResponsiveTables /> },

  // // Maps
  // { path: "/maps-google", component: <MapsGoogle /> },
  // { path: "/maps-vector", component: <MapsVector /> },

  // // Forms
  // { path: "/form-elements", component: <FormElements /> },
  // { path: "/form-advanced", component: <FormAdvanced /> },
  // { path: "/form-editors", component: <FormEditors /> },
  // { path: "/form-uploads", component: <FormUpload /> },
  // { path: "/form-validation", component: <FormValidations /> },

  // // Ui
  // { path: "/ui-alerts", component: <UiAlert /> },
  // { path: "/ui-buttons", component: <UiButtons /> },
  // { path: "/ui-badge", component: <UiBadge /> },
  // { path: "/ui-cards", component: <UiCards /> },
  // { path: "/ui-carousel", component: <UiCarousel /> },
  // { path: "/ui-dropdowns", component: <UiDropdown /> },
  // { path: "/ui-grid", component: <UiGrid /> },
  // { path: "/ui-images", component: <UiImages /> },
  // { path: "/ui-lightbox", component: <UiLightbox /> },
  // { path: "/ui-modals", component: <UiModal /> },
  // { path: "/ui-pagination", component: <UiPagination /> },
  // { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  // { path: "/ui-progressbars", component: <UiProgressbar /> },
  // { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  // { path: "/ui-typography", component: <UiTypography /> },
  // { path: "/ui-video", component: <UiVideo /> },
  // { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  // { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  // { path: "/ui-utilities", component: <UiUtilities /> },
  // { path: "/ui-colors", component: <UiColors /> },
  // { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // //Extra Pages
  // { path: "/pages-timeline", component: <PagesTimeline /> },
  // { path: "/pages-invoice", component: <PagesInvoice /> },
  // { path: "/pages-directory", component: <PagesDirectory /> },
  // { path: "/pages-blank", component: <PagesBlank /> },

  // //userList
  { path: "/user-list", component: <UserList /> },
  // {path:"/portal-user",component:<PortalUserList /> },

  { path: "/Claim-requests",component:<ClaimRequest/>},
  { path: "/business-user-list",component:<BusinessUserList/>},
  { path: "/under18Users",component:<Under18Users/>},

//portal userlist
  { path:"/PortalUsers", component:<PortalUsers/>},
  { path: "/view-user/:userId", component: <ViewAppUser /> },
  { path: "/verify-business-user/:businessId", component: <VerifyBusinessUser /> },
  { path: "/view-portal-user/:userId", component: <ViewPortalUser /> },
  { path: "/userPosts/:userId", component: <UserPostFeed /> },

  // //University
  { path: "/universitylist", component: <UniversityList /> },
  { path: "/addUniversity", component: <AddUniversity /> },
  { path: "/edit-university/:universityCode", component: <EditUniversity /> },
  { path: "/view-university/:universityCode", component: <ViewUniversity /> },

  // //Institution
  { path: "/institutionList", component: <InstitutionDataTable /> },
  { path: "/addInstituion", component: <AddInstitution /> },
  {
    path: "/edit-institution/:institutionCode",
    component: <EditInstitution />,
  },
  {
    path: "/view-institution/:institutionCode",
    component: <ViewInstitution />,
  },
  { path: "/institutions", component: <InstitutionListTable /> },

  //email
  { path: "/EmailTemplateTable", component: <EmailTemplateTable /> },
  { path: "/addEmailTemplate", component: <AppAddEmailTemplate /> },
  { path: "/view-email-template/:id", component: <ViewEmailTemplate /> },
  { path: "/edit-email-template/:id", component: <AppEditEmailTemplate /> },

  //email subscription
  { path: "/emailSubscriptions", component: <EmailSubcription /> },


  //Deleted Users
  { path: "/deleted-users", component: <DeletedUsers /> },
  { path: "/deleted-gabs", component: <DeletedGabs /> },
  { path: "/deleted-comments", component: <DeletedComments /> },
  



  // //Categioy
  { path: "/categoryList", component: <Categorytable /> },
  { path: "/add-category", component: <AddCategory /> },
  { path: "/edit-category/:categoryCode", component: <EditCategory /> },
  { path: "/view-category/:categoryCode", component: <ViewCategory /> },

  // //Prorgam
  { path: "/programList", component: <ProgramList /> },
  { path: "/addProgram", component: <AddProgram /> },
  { path: "/edit-program/:programId", component: <EditProgram /> },
  { path: "/view-program/:programId", component: <ViewProgram /> },

  // //Course
  { path: "/courseList", component: <CourseList /> },
  { path: "/addCourse", component: <AddCourse /> },
  { path: "/edit-course/:courseId", component: <EditCourse /> },
  { path: "/view-course/:courseId", component: <ViewCourse /> },

  //Task
  { path: "/taskList", component: <Tasklist /> },
  { path: "/assignTask", component: <AssignTask /> },
  { path: "/editTask/:taskId", component: <EditTask /> },
  { path: "/myTasks", component: <TaskDataTable /> },
  { path: "/viewTask/:taskId", component: <ViewTask /> },

  {path:"/site-settings",component:<SiteSettings/>},


  //Payments routs
  {path:"/tickets",component:<Tickets/>},
  {path:"/transactions",component:<Transactions/>},
  {path:"/requests",component:<Requests/>},


  //KYC routes
  {path:"/kyc",component:<KYC/>},

  //Forms routes
  {path:"/forms",component:<FormList/>},
  {path:"/addForm",component:<AddForm/>},
  {path:"/edit-form/:formId",component:<EditForm/>},
  {path:"/all-responses",component:<ResponseList/>},
  {path:"/view-response/:responseId",component:<ViewResponse/>},

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { userRoutes, authRoutes }
